import React from 'react';
import { Helmet } from 'react-helmet';

const REACT_APP_GOOGLE_TAG_MANAGER_KEY =
	process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY;

const GoogleTagManager = () => (
	<Helmet>
		<script>
			{`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${REACT_APP_GOOGLE_TAG_MANAGER_KEY}');
        `}
		</script>
	</Helmet>
);

export default GoogleTagManager;

export let dataLayer = [];

const setDataLayer = () =>
	setTimeout(() => {
		if (window.dataLayer) {
			if (dataLayer.length) {
				// keep track of any events pushed before tag manager is loaded and reapply them once tag manager is in place
				dataLayer.forEach((item) => window.dataLayer.push(item));
			}
			dataLayer = window.dataLayer;
		} else {
			setDataLayer();
		}
	}, 100);

setDataLayer();

export const customEvent = (event, props = {}) =>
	dataLayer.push({ event, ...props });

export const generateAlertTrackingEvents = (prefix, alerts) => {
	alerts.forEach((key) =>
		customEvent(`${prefix}_${key.replace(/Checks$/, '')}`, '')
	);
};
